export function Disclaimer() {
  return (
    <p className="text-xxs text-muted-foreground text-left">
      Calculators are for illustrations only and do not represent actual
      returns.
    </p>
  );
}
